import { useDeleteTheme } from '@/api/glow-up/glow-up.hooks';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Theme } from '@repo/types/src/glow-up';
import { Trash2 } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

type DeleteThemeProps = {
  theme: Theme;
  refetch: () => void;
};

export const DeleteTheme = ({ theme, refetch }: DeleteThemeProps) => {
  const mutation = useDeleteTheme();
  const [open, setOpen] = useState(false);

  const handleDelete = () => {
    mutation.mutate(theme.id, {
      onSuccess: () => {
        setOpen(false);
        refetch();
        toast.success(`Le thème ${theme.title} a été supprimé avec succès!`, {
          duration: 3000,
        });
      },
      onError: () => {
        toast.error(`Erreur lors de la suppression du thème ${theme.title}`, {
          duration: 3000,
        });
      },
    });
  };

  const isLoading = mutation.isPending;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="destructive" size="sm" disabled={isLoading}>
          <Trash2 size={16} />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-center">Supprimer le thème</DialogTitle>
          <DialogDescription className="text-center">
            Êtes-vous sûr de vouloir supprimer le thème "{theme.title}" ? Cette
            action supprimera également toutes les catégories et exercices
            associés et est irréversible.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex gap-2">
          <DialogClose asChild>
            <Button variant="ghost" disabled={isLoading}>
              Annuler
            </Button>
          </DialogClose>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={isLoading}
          >
            {isLoading ? 'Suppression...' : 'Supprimer'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
